// extracted by mini-css-extract-plugin
module.exports = {"aboutUsPage":"AboutUsPage_aboutUsPage__2I7XM","picOfSifu":"AboutUsPage_picOfSifu__UnRHV","details":"AboutUsPage_details__QmYQo"};